// extracted by mini-css-extract-plugin
var _1 = "CalendarGridWeekAllDayCell-moduleCalendarGridWeekAllDayCell__cm8uV";
var _2 = "CalendarGridWeekAllDayCell-moduletoday__i_bYv";
export { _1 as "CalendarGridWeekAllDayCell", _2 as "today" }
